<template>
    <GChart class="simomicsBarChart" ref="chart" type="ColumnChart" :data="chartData" :options="chartOptions"
        :style="{'height' : height + 'px'}" style="min-height:200px;" />
</template>

<script>
    import { GChart } from 'vue-google-charts'
    import { BarChartData } from '../../../ts/charts/barChartData'

    export default {
        components: {
            GChart
        },

        props: {
            barChartData: {
                type: BarChartData
            },
            height: {
                default: 300
            }
        },

        data() {
            return {
                chartData: null,
                chartOptions: null
            }
        },
        mounted() {
            this.update();
            window.addEventListener('resize', this.update);
        },
        watch: {
            barChartData() {
                this.update()
            }
        },
        methods: {
            update() {
                this.$emit("loading")
                this.$nextTick(() => {
                    let data = [this.barFormat()]
                    if (!this.barChartData.bars) {
                        return // TODO: add loading..
                    }
                    for (const bar of this.barChartData.bars) {
                        data.push(this.addBar(bar))
                    }

                    this.chartOptions = this.generateChartOptions(Math.max(...this.barChartData.bars.map(o => o.value)))

                    this.chartData = data
                    this.$nextTick(() => {
                        this.$emit("loaded")
                    })
                })
            },
            barFormat() {
                // TODO: could generate these from col. data.
                return [ // Columns
                    'xaxis', // X-axis
                    'yaxis', // Y-axis
                    { // color (of the bar)
                        'role': 'style',
                    },
                    { // tooltip (appears on click for mobile, hover for pc)
                        'type': 'string',
                        'role': 'tooltip',
                        'p': {
                            'html': true
                        }
                    },
                    { // annotation (above chart)
                        'role': 'annotation',
                    },
                    { // tooltip [REPEATED - not too many bars so okay..] (appears on click for mobile, hover for pc)
                        'type': 'string',
                        'role': 'annotationText',
                        'p': {
                            'html': true
                        }
                    },
                ]
            },
            generateChartOptions(maxValue) {
                return {
                    'legend': {
                        'position': 'none'
                    },
                    'chartArea': {
                        'width': "85%",
                        'height': "75%",
                    },
                    'tooltip': {
                        'isHtml': true
                    },
                    'vAxis': {
                        'gridlineColor': '#fff',
                        'textPosition': 'none',
                        'maxValue': maxValue * 1.25 // put 10% space on top for label to fit.
                    },
                    'bar': {
                        'groupWidth': "70%",
                    }
                }
            },
            addBar(bar) {
                return [
                    bar.label,
                    bar.value,
                    bar.color,
                    this.generateTooltip(bar),
                    this.roundAtleastFourNumbers(bar.value) + bar.units, // small labels are put into bars. Fixing a minimum number size prevents this from happening.
                    this.generateTooltip(bar),
                ]
            },
            generateTooltip(bar) {
                return `
				<div style="padding: 10px; font-size:8pt; border: 3px solid ` + bar.color +
                    `">
					<span style="white-space:nowrap; font-weight: bold;">` + bar.name +
                    `</span></br>
					<span style="white-space:nowrap">` + bar.description +
                    `</span></br></br>
					<span style="white-space:nowrap; font-weight: bold;">RQ Frequency: ` + this.roundAtleastFourNumbers(bar.value) + " " + bar.units +
                    `</span>
				</div>
				`
            },
            roundAtleastFourNumbers(val) {
                let rounded = (Math.round((val + Number.EPSILON) * 1000) / 1000).toString()
                if (rounded.includes(".")) {
                    rounded = rounded.substring(0, 5)
                    rounded = rounded.padEnd(5, "0")
                }
                if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                    // CAREFUL: I'm replacing &#46; with: &#8228; to prevent error where firefox wraps decimals.
                    // Annoyingly, this fix breaks other versions - hence the explicit firefox check.
                    rounded = rounded.replace(".", "․")
                }
                return rounded
            }
        },
    }

</script>

<style>
    /* Vueitfy dialog index is 201. Tooltip by default is 10000. Which isn't sensible. */
    .simomicsBarChart .google-visualization-tooltip {
        z-index: 180 !important
    }
</style>